import { Controller } from '@hotwired/stimulus';

import consumer from '../../channels/consumer';

export default class extends Controller {
  static values = {
    asyncTaskId: Number,
    redirectBasePath: String,
    paramName: String,
  };

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: 'AsyncTasksChannel', room: window.currentUserId || 0 },
      {
        connected: () => {},
        disconnected: () => {},
        received: (data) => this.handleMessage(data),
      }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  handleMessage(data) {
    const asyncTask = JSON.parse(data);

    if (asyncTask.id !== this.asyncTaskIdValue) return;

    if (asyncTask.status === 'completed') {
      console.log(asyncTask.result, this.paramNameValue);
      const resultValue =
        asyncTask.result && asyncTask.result[this.paramNameValue];

      const url = new URL(this.redirectBasePathValue, window.location.origin);

      if (
        resultValue !== undefined &&
        resultValue !== null &&
        resultValue !== ''
      ) {
        url.searchParams.set(this.paramNameValue, resultValue);
      }

      if (this.subscription) this.subscription.unsubscribe();
      window.Turbo.visit(url.toString());
    }
  }
}
